export const emptyBillingListState = {
  entries: [],
  listStatus: 'idle',
  isLoading: false
}
